import moment from 'moment/moment'

const rawDateFormats = ['YYYY', 'YYYYMM', 'YYYYMMDD', 'YYYYMMDDHH', 'YYYYMMDDHHmm', 'YYYYMMDDHHmmss']

const dateFormats = ['YYYY', 'M/YYYY', 'D. M. YYYY', 'D. M. YYYY HH', 'D. M. YYYY HH:mm', 'D. M. YYYY HH:mm:ss']

const toRawDate = (val) => {
    if (typeof val === 'string') {
        const tokens = val.split(/[^0-9]/)
        const cnt = tokens.length

        for (let i = 0; i < cnt; i += 1) {
            if (tokens[i].length > 4) {
                return null
            }
        }

        if (cnt >= 1 && cnt <= 6) {
            const date = moment(val, dateFormats[cnt - 1])
            if (date.isValid() && date.year() >= 1000) {
                return date.format(rawDateFormats[cnt - 1])
            }
        }
        return null
    }

    return null
}

export const parseSearch = (text) => {
    const spaceless = text.replace(/\s+/g, '')
    if (/^([0-9]{8})$/.test(spaceless)) {
        text = spaceless // eslint-disable-line
    }

    const tokens = text.split(/[\s,]+/)

    const resTokens = []

    for (let i = 0; i < tokens.length; i += 1) {
        const token = tokens[i]
        if (token.length < 2) continue // eslint-disable-line

        const rawDate = toRawDate(token)
        if (rawDate) {
            resTokens.push(rawDate)
        } else {
            resTokens.push(token)
        }
    }
    return resTokens.join(' ')
}

export const getStoredData = (storageSearchCollection, searchValue) =>
    storageSearchCollection.find((storageCollectionElement) => storageCollectionElement.searchValue === searchValue)
